import { render, staticRenderFns } from "./siteOrder.vue?vue&type=template&id=dd6f6ad0&scoped=true&"
import script from "./siteOrder.vue?vue&type=script&lang=js&"
export * from "./siteOrder.vue?vue&type=script&lang=js&"
import style0 from "./siteOrder.vue?vue&type=style&index=0&id=dd6f6ad0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6f6ad0",
  null
  
)

export default component.exports